<template>
  <div class="tyrion_price_slider">
    <div class="wrapper">

      <div class="row price-input mb-5">
        <div class="col-6">
          <div class="field text-start">
            <span class="d-block text-silver">Min</span>
            <input type="text" :value="formatPrice(from, activeLocale.code)" readonly>
          </div>

        </div>
        <div class="col-6">
          <div class="field text-end">
            <span class="text-silver">Max</span>
            <input type="text" class="text-end" :value="formatPrice(to, activeLocale.code)" readonly>
          </div>
        </div>
      </div>

      <div class="slider">
        <div class="progress"></div>
      </div>
      <div class="range-input">
        <input type="range" class="range-min" :min="min_value" :max="max_value" :step="step"
               v-model="from" @change="parentChange">
        <input type="range" class="range-max" :min="min_value" :max="max_value" :step="step"
               v-model="to" @change="parentChange">
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {onMounted, PropType, Ref, ref, watch} from "vue";
import {formatPrice, switchCurrencyMark} from "../../../lib/functions";

const emit = defineEmits(['change']);
const props = defineProps({
  min_value: Number,
  max_value: Number,
  open: Boolean,
  step: Number,
  currency: String,
  activeLocale: Object as PropType<{ code: string }>,
  default: Object
})

const from = ref(props.default && props.default.from ? props.default.from : props.min_value);
const to = ref(props.default && props.default.to ? props.default.to : props.max_value);
const setDefaultTimeout: Ref<number | null> = ref(null);

onMounted(() => {
  setDefault();
  const rangeInput = document.querySelectorAll(".range-input input");

  rangeInput.forEach((input) => {
    input.addEventListener("input", (e) => {
      updateSliderValue(e);
    });
  });
});

watch(() => props.default, () => {
  setDefault();
});


watch(() => props.min_value, () => {
  if (from.value < props.min_value) {
    from.value = props.min_value;
    updateSliderValue(null);
  }
});

watch(() => props.max_value, () => {
  if (to.value > props.max_value) {
    to.value = props.max_value;
    updateSliderValue(null);
  }
});

watch(() => props.open, () => {
  updateSliderValue(null);
});

const setDefault = () => {
  if (setDefaultTimeout.value !== null) clearTimeout(setDefaultTimeout.value);
  setDefaultTimeout.value = setTimeout(() => {

    from.value = props.default && props.default.from ? props.default.from : from.value;
    to.value = props.default && props.default.to ? props.default.to : to.value;
    updateSliderValue(null);
  }, 100);
}

const parentChange = () => {
  emit('change', {from: from.value, to: to.value});
}


const updateSliderValue = (e) => {
  const rangeInput = document.querySelectorAll(".range-input input");
  const range = document.querySelector(".slider .progress");
  let priceGap = props.step;

  let minVal = parseInt(rangeInput[0].value),
      maxVal = parseInt(rangeInput[1].value);

  let minRange = parseInt(rangeInput[0].min),
      maxRange = parseInt(rangeInput[0].max);

  if (maxVal - minVal < priceGap) {
    if (e && e.target.className === "range-min") {
      rangeInput[0].value = maxVal - priceGap;
      from.value = Number(rangeInput[0].value);
    } else {
      rangeInput[1].value = minVal + priceGap;
      to.value = Number(rangeInput[1].value);
    }
  } else {
    let leftPercent = ((minVal - minRange) / (maxRange - minRange)) * 100;
    let rightPercent = 100 - ((maxVal - minRange) / (maxRange - minRange)) * 100;

    range.style.left = leftPercent + "%";
    range.style.right = rightPercent + "%";
  }
}

</script>

<style scoped>

.wrapper {
  width: 100%;
}

.price-input input {
  border: none;
  width: 100%;
  font-weight: bold;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}


.slider {
  height: 5px;
  position: relative;
  background: #ddd;
  border-radius: 5px;
}

.slider .progress {
  height: 100%;
  left: 25%;
  right: 25%;
  position: absolute;
  border-radius: 5px;
  background: var(--first-color);
}

.range-input {
  position: relative;
}

.range-input input {
  position: absolute;
  width: 100%;
  height: 5px;
  left: 0;
  top: -5px;
  background: none;
  pointer-events: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  /*&.range-min{

    &:after{
      content: "min.";
      position: absolute;
      top: 0;
      font-size: 0.6rem;
      font-weight: 500;
      width: 2rem;
      height: 2rem;
      transform: translateY(-0.9rem);
      margin: 0;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
    }
  }

  &.range-max{

    &:after{
      content: "max.";
      position: absolute;
      top: 0;
      font-size: 0.6rem;
      font-weight: 500;
      width: 2rem;
      height: 2rem;
      transform: translateY(-0.9rem);
      margin: 0;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
    }
  }*/
}

input[type="range"]::-webkit-slider-thumb {
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
  border: 4px solid var(--first-color);
  background: white;
  pointer-events: auto;
  -webkit-appearance: none;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);
  cursor: grab;



}

input[type="range"]::-moz-range-thumb {
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 50%;
  border: 4px solid var(--first-color);
  background: white;
  pointer-events: auto;
  -moz-appearance: none;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);
}


</style>
